import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-837f4480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "proposal-send" }
const _hoisted_2 = { class: "proposal-send__title wrapper" }
const _hoisted_3 = { class: "flex flex-row mt-2 -mx-2" }
const _hoisted_4 = { class: "w-4/12 px-2" }
const _hoisted_5 = { class: "proposal-send__recipients p-5 wrapper h-full" }
const _hoisted_6 = { class: "proposal-send__heading" }
const _hoisted_7 = { class: "proposal-send__recipients__addresses table w-full mt-7" }
const _hoisted_8 = { class: "table-cell proposal-send__recipients__addresses__address__label" }
const _hoisted_9 = { class: "table-cell proposal-send__recipients__addresses__address__email" }
const _hoisted_10 = { class: "table-cell proposal-send__recipients__addresses__address__edit-icon" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-edit" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1))
const _hoisted_18 = { class: "w-8/12 px-2" }
const _hoisted_19 = { class: "proposal-send__message p-5 wrapper h-full" }
const _hoisted_20 = { class: "flex justify-between items-center" }
const _hoisted_21 = { class: "proposal-send__heading w-28" }
const _hoisted_22 = { class: "w-full flex" }
const _hoisted_23 = { class: "proposal-send__heading w-28" }
const _hoisted_24 = { class: "w-full flex" }
const _hoisted_25 = { class: "text-light flex items-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pdf ml-3 text-medium" }, null, -1))
const _hoisted_27 = { class: "flex flex-row items-center mt-8" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-send mr-2" }, null, -1))
const _hoisted_29 = { class: "font-normal" }
const _hoisted_30 = { class: "form" }
const _hoisted_31 = { class: "form__group flex flex-row -mx-2" }
const _hoisted_32 = { class: "form__group__label flex items-end content-end w-2/12 px-2" }
const _hoisted_33 = {
  for: "email",
  class: "font-default"
}
const _hoisted_34 = { class: "form__group__control w-10/12 px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_proposal_header = _resolveComponent("proposal-header")!
  const _component_layout_header = _resolveComponent("layout-header")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layout_header, null, {
      default: _withCtx(() => [
        (_ctx.customer)
          ? (_openBlock(), _createBlock(_component_proposal_header, {
              key: 0,
              customer: _ctx.customer,
              proposal: _ctx.proposal
            }, null, 8, ["customer", "proposal"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('proposal.send.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('proposal.send.recipients.heading')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipients, (recipient) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `recipient-${recipient.email}`,
                class: "table-row proposal-send__recipients__addresses__address"
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('proposal.send.recipients.address.label')), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(recipient.email), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.edit(recipient))
                  }, _hoisted_13, 8, _hoisted_11),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.remove(recipient))
                  }, _hoisted_16, 8, _hoisted_14)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: "proposal-send__recipients__add-email",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddRecipientModal = true))
          }, [
            _hoisted_17,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.send.recipients.address.add_address')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('proposal.send.message.message_heading')), 1)
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('proposal.send.message.sent_from', {'from': 'name@parcel4you.com'})), 1)
          ]),
          _withDirectives(_createElementVNode("textarea", {
            class: "default-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event))
          }, null, 512), [
            [_vModelText, _ctx.message]
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('proposal.send.message.attachments_heading')), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_25, [
                _createTextVNode(_toDisplayString(_ctx.$t('general.attachments.pdf')) + " ", 1),
                _hoisted_26
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_outline_button, {
        disabled: !_ctx.recipients.length || !_ctx.message
      }, {
        default: _withCtx(() => [
          _hoisted_28,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.send.buttons.send')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_outline_button, {
        type: "outline",
        class: "ml-4"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('general.cancel')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showAddRecipientModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAddRecipientModal) = $event)),
      onConfirmClick: _ctx.handleConfirmClick
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('proposal.send.add_email.title')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('proposal.send.add_email.email')), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  id: "email",
                  class: "default-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirmClick"])
  ]))
}